import $ from "jquery";

export default() => {
    ((popupFocus, $) => {
        const KEY_TAB = 9;
        const KEY_ESC = 27;
        var $popup, focusableEls, focusedElBeforeOpen, firstFocusableEl, lastFocusableEl;

        popupFocus.open = function(popup) {
            focusedElBeforeOpen = document.activeElement;
            $popup = popup;
            focusableEls = $popup.get(0).querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
            focusableEls = Array.prototype.slice.call(focusableEls);
            $popup.attr('aria-hidden', false);
            focusableEls[0].focus();
        }

        popupFocus.update = function() {
            focusableEls = $popup.get(0).querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
            focusableEls = Array.prototype.slice.call(focusableEls);
            firstFocusableEl = focusableEls[0];
            lastFocusableEl = focusableEls[focusableEls.length - 1 ];
        }
    
        popupFocus.close = function() {
            if(!$popup) {
                return
            }
            $popup.attr('aria-hidden', true);
            if (focusedElBeforeOpen) {
                focusedElBeforeOpen.focus();
            }
        }
        
        popupFocus.init = function() {
            $(document).on('keydown', function(e) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode === KEY_TAB) {
                    if(!focusableEls) {
                        return
                    }
                    popupFocus.update()
                    if(e.shiftKey) { // backward tab
                        if ( document.activeElement === firstFocusableEl ) {
                            e.preventDefault();
                            lastFocusableEl.focus();
                        }
                    } else { // forward tab
                        if ( document.activeElement === lastFocusableEl ) {
                            e.preventDefault();
                            firstFocusableEl.focus();
                        }
                    }
                }
                else if (keycode === KEY_ESC) {
                    popupFocus.close();
                }
            })
        }

        var menuKeyboard = {};
        menuKeyboard.init = function() {
            var $topMenuItem = $('.desktop-menubar .menu_link[role="menuitem"]');
            var $subMenuItem = $('.mega-menu__item .sub_links[role="menu"] a[role="menuitem"]');

            function openSubmenu($menuitem) {
                $menuitem.parents('.mega-menu__items').find('.flymenu-item li').removeClass('active');
                $menuitem.parents('.mega-menu__items').find('.flymenu-item li').attr('aria-expanded', 'false');
                var target = $menuitem.data('target');
                $menuitem.parents('.mega-menu__items').find('.mega-menu__item').not('.flymenu-item').hide();
                $('.mega-menu__item.' + target).show();
                $menuitem.parent().addClass('active');
                $menuitem.attr('aria-expanded', 'true');
            }

            $topMenuItem.on('keydown', function (event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if ((keycode === 13 || keycode === 32) && $(this).attr('aria-haspopup') !== 'true') {
                    window.location.href = $(this).get(0).href;
                }

                if (keycode === 13 || keycode === 32 || keycode === 38 || keycode === 40) { // enter, space, down or up arrow
                    event.preventDefault();
                    $('.desktop-menubar .leading-none.mega-hover').removeClass('open');
                    $topMenuItem.attr('aria-expanded', 'false');
                    $(this).parents('.mega-hover').addClass('open');
                    $(this).attr('aria-expanded', 'true');

                    if(keycode === 38) {
                        $(this).next().find('a[role="menuitem"]:visible').last().focus();
                    } else {
                        $(this).next().find('a[role="menuitem"]').first().focus();
                    }
                } else if(keycode === 37) { //left arrow
                    $(this).attr('tabindex', '-1');
                    var $prev = $(this).parent().prev().find('.menu_link');
                    if($prev.length) {
                        $prev.focus()
                        $prev.attr('tabindex', '0');
                    } else {
                        $prev = $(this).parents('.nav').find('.menu_link').last();
                        $prev.focus();
                        $prev.attr('tabindex', '0');
                    }
                } else if(keycode === 39) { //right arrow
                    $(this).attr('tabindex', '-1');
                    var $next = $(this).parent().next().find('.menu_link');
                    if($next.length) {
                        $next.focus()
                        $next.attr('tabindex', '0');
                    } else {
                        $next = $(this).parents('.nav').find('.menu_link').first();
                        $next.focus();
                        $next.attr('tabindex', '0');
                    }
                } else if (keycode === 27) { //Esc key
                    $topMenuItem.attr('aria-expanded', 'false');
                    $('.desktop-menubar .leading-none.mega-hover').removeClass('open');
                }
            })

            //menu level 2 items
            $subMenuItem.on('keydown', function (event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if ((keycode === 13 || keycode === 32) && $(this).attr('aria-haspopup') !== 'true') {
                    window.location.href = $(this).get(0).href;
                }
            
                if (keycode === 13 || keycode === 32) { //enter, space or down arrow
                    event.preventDefault();
                    openSubmenu($(this))
                    var $target = $('.mega-menu__item.' + $(this).data('target'));
                    $target.find('[role="menuitem"]').first().focus();
                } else if(keycode === 37) { //left arrow
                    event.preventDefault();
                    var $prev = $(this).parent().prev().find('[role="menuitem"]');
                    var $target = $('.mega-menu__item.' + $(this).data('target'));
                    $target.find('[role="menuitem"]').last().focus();
                } else if(keycode === 39) { //right arrow
                    event.preventDefault();
                    var $target = $('.mega-menu__item.' + $(this).data('target'));
                    $target.find('[role="menuitem"]').first().focus();
                } else if(keycode === 38) { //up arrow
                    event.preventDefault();
                    $(this).attr('tabindex', '-1');
                    var $prev = $(this).parent().prev().find('[role="menuitem"]');
                    if($prev.length) {
                        $prev.focus();
                        $prev.attr('tabindex', '0');
                        openSubmenu($prev)
                    } else {
                        $prev = $(this).parents('[role="menu"]').find('[role="menuitem"]').last()
                        $prev.focus();
                        $prev.attr('tabindex', '0');
                        openSubmenu($prev)
                    }
                } else if(keycode === 40) { //down arrow
                    event.preventDefault();
                    var $next = $(this).parent().next().find('[role="menuitem"]');
                    $(this).attr('tabindex', '-1');
                    if($next.length) {
                        $next.focus();
                        $next.attr('tabindex', '0');
                        openSubmenu($next)
                    } else {
                        $next = $(this).parents('[role="menu"]').find('[role="menuitem"]').first();
                        $next.focus();
                        $next.first().attr('tabindex', '0');
                        openSubmenu($next)
                    }
                } else if (keycode === 27) { //Esc key
                    $topMenuItem.attr('aria-expanded', 'false');
                    $('.nav .leading-none > [role="menuitem"][tabindex="0"]').focus()
                    $('.desktop-menubar .leading-none.mega-hover').removeClass('open');
                }
            })

            //menu level 3 items
            $('.submenu-item [role="menuitem"]').on('keydown', function (event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if ((keycode === 13 || keycode === 32) && $(this).attr('aria-haspopup') !== 'true') {
                    window.location.href = $(this).get(0).href;
                }

                var target = [];
                $(this).parent()[0].classList.value.split(' ').forEach(function(ele) {
                    if(ele.indexOf(':') === -1) {
                        target.push(ele)
                    }
                })
                target = target.join('.')
                var $target = $('.' + target)
            
                if(keycode === 38) { //up arrow
                    event.preventDefault();
                    if($(this).closest('.sub-nav').length) {
                        event.preventDefault();
                        $(this).attr('tabindex', '-1');
                        var $prev = $(this).parent().prev().find('[role="menuitem"]');
                        if($prev.length) {
                            $prev.focus();
                            $prev.attr('tabindex', '0');
                        } else {
                            $prev = $(this).closest('[role="menu"]').find('[role="menuitem"]').last();
                            $prev.focus();
                            $prev.attr('tabindex', '0');
                        }
                    }
                } else if(keycode === 40) { //down arrow                    
                    if($(this).closest('.sub-nav').length) {
                        event.preventDefault();
                        $(this).attr('tabindex', '-1');
                        var $next = $(this).parent().next().find('[role="menuitem"]');
                        if($next.length) {
                            $next.focus();
                            $next.attr('tabindex', '0');
                        } else {
                            $next = $(this).closest('[role="menu"]').find('[role="menuitem"]').first();
                            $next.focus();
                            $next.attr('tabindex', '0');
                        }
                    }
                } else if(keycode === 37) { //left arrow
                    if($(this).closest('.horizontal-item').length) {
                        event.preventDefault();
                        $(this).attr('tabindex', '-1');
                        var $prev = $(this).parent().prev().find('[role="menuitem"]');
                        var isPrev = $prev.length && $(this).parent().prev().is('.' + target);
                        if(isPrev) {
                            $prev.focus()
                            $prev.attr('tabindex', '0');
                        } else {
                            $prev = $target.find('[role="menuitem"]').last();
                            $prev.focus();
                            $prev.attr('tabindex', '0');
                        }
                    }
                } else if(keycode === 39) { //right arrow
                    if($(this).closest('.horizontal-item').length) {
                        event.preventDefault();
                        $(this).attr('tabindex', '-1');
                        var $next = $(this).parent().next().find('[role="menuitem"]');
                        var isNext = $next.length && $(this).parent().next().is('.' + target);
                        if(isNext) {
                            $next.focus();
                            $next.attr('tabindex', '0');
                        } else {
                            $next = $target.find('[role="menuitem"]').first();
                            $next.focus();
                            $next.first().attr('tabindex', '0');
                        }
                    }
                } else if (keycode === 27) { //Esc key
                    $('.mega-menu__item .sub_links[role="menu"] li.active:visible').find('[role="menuitem"]').focus();
                }
            })

            $(document).on('mousedown', function(e) {
                if(!$(e.target).parents('.desktop-menubar').length) {
                    $topMenuItem.attr('aria-expanded', 'false');
                    $('.desktop-menubar .leading-none.mega-hover').removeClass('open');
                }
            })
        }

        menuKeyboard.init();
        popupFocus.init();

        // Store locater changes  
        if($('#store_map').length && $(window).width() > 700){
            $('<div class="map-lists-wrapper flex"></div>').insertBefore('#store_map');
            $('.map-lists-wrapper').append($('#addresses_list').detach());
            $('.map-lists-wrapper').append($('#directions_text').detach());
            $('.map-lists-wrapper').append($('#store_map').detach());
        }
        // Form errors accessibility  
        if($('.template-login , .template-register').length){
           $('form').on('submit',function(){
                var isValid=true;
                var emailRegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                $(this).find('input.required').each(function(){
                    var inputType = $(this).attr('type');
                    var id=$(this).attr('id');
                    id=id+'-error';
                    $(this).removeAttr('aria-describedby');
                    $(this).removeClass('has-error');
                    if($(this).val()==''){
                        isValid=false;
                        $(this).addClass('has-error');
                        $(this).attr('aria-describedby',id);
                    }
                    if(inputType=='email' && !emailRegExp.test($(this).val())){
                        isValid=false;
                        $(this).addClass('has-error');
                        $(this).attr('aria-describedby',id);
                    }
                });
                setVoiceOverFocus($(this).find('input.has-error').first())
                return isValid;
           });

        }
        function setVoiceOverFocus(element) {
            var focusInterval = 10; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions
          
            element.attr('tabindex', '0');
            element.blur();
          
            var focusRepetitions = 0;
            var interval = window.setInterval(function() {
              element.focus();
              focusRepetitions++;
              if (focusRepetitions >= focusTotalRepetitions) {
                window.clearInterval(interval);
              }
            }, focusInterval);
          }
    })
    (window.popupFocus = window.popupFocus || {}, $)
}
